<template>
  <div class="container">
    <div class="row mt-lg-n10 mt-md-n11 mt-n10 justify-content-center">
      <div class="mx-auto col-xl-4 col-lg-5 col-md-7">
        <div class="card z-index-0 mt-10">
          <div class="card-body">
            <soft-badge
              color="warning"
              variant="gradient"
              size="sm"
              @click="$emit('close')"
              class="cursor-pointer float-right"
            >
              {{ $t("global.close") }}
            </soft-badge>
            <p class="my-3 text-bold">{{ $t("parents.editingParent") }}</p>

            <form @submit.prevent="submitForm">
              <div class="mb-3">
                <span class="text-xs text-secondary mb-0"
                  >({{ $t("parents.name") }})</span
                >
                <InputForm
                  v-model="formData.parent_name"
                  :placeholder="parent.parent_name"
                  type="text"
                />
              </div>
              <div class="mb-3">
                <span class="text-xs text-secondary mb-0"
                  >({{ $t("teachers.mobile") }})</span
                >
                <InputForm
                  v-model="formData.mobile"
                  :placeholder="parent.mobile"
                  type="text"
                />
              </div>
              <div class="mb-3">
                <span class="text-xs text-secondary mb-0"
                  >({{ $t("parents.notes") }})</span
                >
                <InputForm
                  v-model="formData.notes"
                  :placeholder="parent.notes"
                  type="text"
                />
              </div>

              <div class="align-text-center justify-content-center">
                <div class="w-1">
                  <img :src="parent.image" class="right-img mb-2 mx-2" />
                </div>
                <label
                  style="display: inline-block"
                  for="file"
                  :v-model="formData.file"
                  class="mx-2 custom-file-upload"
                  ><span>{{ $t("global.uploadImage") }}</span>
                </label>
                <input
                  type="file"
                  id="file"
                  @change="handleFileUpload"
                  accept="image/*"
                />
              </div>

              <div class="text-center">
                <soft-button
                  color="dark"
                  full-width
                  variant="gradient"
                  class="my-4 mb-2"
                >
                  {{ $t("global.edit") }}
                </soft-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import InputForm from "@/components/InputForm.vue";
import SoftButton from "@/components/SoftButton.vue";
import SoftBadge from "@/components/SoftBadge.vue";
import swal from "sweetalert2";

export default {
  name: "FormCreateTeacher",
  components: {
    InputForm,
    SoftButton,
    SoftBadge,
  },
  props: {
    parent: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formData: {
        id: this.parent.id,
        parent_name: "",
        mobile: "",
        notes: "",
      },
      selectedFile: "",
      imageUrl: "",
    };
  },
  methods: {
    async submitForm(event) {
      event.preventDefault();
      const formData = new FormData();
      formData.append("_method", "PATCH");
      formData.append("id", this.parent.id);
      if (this.formData.parent_name) {
        formData.append("parent_name", this.formData.parent_name);
      }
      if (this.formData.mobile) {
        formData.append("mobile", this.formData.mobile);
      }
      if (this.formData.notes) {
        formData.append("notes", this.formData.notes);
      }
      if (this.selectedFile != "") {
        formData.append("image", this.selectedFile);
      }
      try {
        const response = await axios.post(
          "parent/" + this.parent.id,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        swal.fire({
          icon: "success",
          title: this.$t(response.data.message),
          showConfirmButton: false,
          timer: 2000,
        });
        this.$emit("form-submitted");
      } catch (error) {
        if (error.response && error.response.status === 422) {
          const errors = error.response.data.errors;
          let errorMessages = "";

          if (typeof errors === "function") {
            for (const key in errors) {
              if (errors.prototype.hasOwnProperty.call(errors, key)) {
                errorMessages += `- ${errors[key].join(", ")}\n`;
                swal.fire({
                  title: this.$t("global.error"),
                  html: errorMessages.replace(/\n/g, "<br>"),
                  icon: "error",
                  position: "top-end",
                });
              }
            }
          } else {
            for (const key in errors) {
              errorMessages += `- ${errors[key].join(", ")}\n`;
              swal.fire({
                title: this.$t("global.error"),
                html: errorMessages.replace(/\n/g, "<br>"),
                icon: "error",
                position: "top-end",
              });
            }
          }
        }
      }
      this.resetForm();
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      this.selectedFile = file;

      this.imageUrl = URL.createObjectURL(file);
    },
    resetForm() {
      this.formData.parent_name = "";
      this.formData.mobile = "";
      this.formData.notes = "";
      this.selectedFile = "";

      return;
    },
  },
};
</script>

<style scoped>
.float-right {
  float: right;
}

.custom-file-upload {
  display: inline-block;
  padding: 10px 20px;
  cursor: pointer;
  background: linear-gradient(to right, #7fe02f, #2cb735);
  color: white;
  border-radius: 8px;
}

#file {
  display: none;
}

.custom-file-upload span {
  pointer-events: none;
}

.float-right {
  float: right;
}

.right-img {
  position: relative;
  border: 1px solid gray;
  padding: 6px;
  border-radius: 8px;
  width: 125px !important;
  height: 125px !important;
}
</style>
